import { render, staticRenderFns } from "./order-tabs.vue?vue&type=template&id=efdea8be&scoped=true&"
import script from "./order-tabs.vue?vue&type=script&lang=js&"
export * from "./order-tabs.vue?vue&type=script&lang=js&"
import style0 from "./order-tabs.vue?vue&type=style&index=0&id=efdea8be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdea8be",
  null
  
)

export default component.exports